let checkout = {
    init() {
        $(document).click(function(event) {
            if ( $(event.target).hasClass('b-widget-colissimo')) {
                $(".b-widget-colissimo").fadeOut(300);
                $('body').removeClass('noscroll');
            }
        });
        $('.b-widget-colissimo .close').click(function(){
            $(".b-widget-colissimo").fadeOut(300);
            $('body').removeClass('noscroll');
        })
    }
}

export default checkout;

